import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _, { isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { despesaReceitaAPI } from '../../features/despesa-receita/despesaReceitaAPI';
import {
  fetchAllAsync,
  selectDespesasReceitas,
  setList,
} from '../../features/despesa-receita/despesaReceitaSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectDespesaReceitaAutocomplete({
  label,
  name,
  initialValues,
  filterParams,
  filtrarDespesaReceita = false, 
  ...restProps
}) {
  const dispatch = useDispatch();
  const list = useSelector(selectDespesasReceitas);
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    let ativo = true;

    const carregar = async () => {
      if (!isEmpty(filterParams)) {
        const response = await despesaReceitaAPI.fetchByFilter(filterParams);
        if (!ativo) return;

        if (response?.status === 200) {
          dispatch(setList({ data: response?.data }));
        }
        return;
      }

      dispatch(fetchAllAsync());
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [dispatch, filterParams]);

  // ✅ filtra só para exibição (não altera store)
  const options = useMemo(() => {
    if (!filtrarDespesaReceita) return list;

    return (list || []).filter((item) => {
      const tipo = (item?.tipo || '').toString().toUpperCase();
      return tipo === 'DESPESA' || tipo === 'RECEITA';
    });
  }, [list, filtrarDespesaReceita]);

  useEffect(() => {
    const value = (options || []).find((item) => item?.id === _.get(initialValues, name));

    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }

    const fieldDescription = 'ignorableFields.lancamento.despesaReceita.description';
    if (!value && _.isNumber(_.get(initialValues, name)) && _.get(initialValues, fieldDescription)) {
      const valueEdit = _.get(initialValues, 'ignorableFields.lancamento.despesaReceita');
      setDefaultValue(valueEdit);
    }
  }, [options, initialValues, name]);

  const filterOptions = createFilterOptions({
    stringify: (option) => `${option?.id} - ${option?.description}`,
  });

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={options} 
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) =>
        item?.id && item?.description ? `${item?.id} - ${item?.description}` : ''
      }
      {...restProps}
    />
  );
}
